import * as __vanilla_filescope__ from '@vanilla-extract/css/fileScope';
__vanilla_filescope__.setFileScope("src/styles.css.ts", "@paypalcorp/pp-react-shimmer");
import { keyframes, style as _style } from '@vanilla-extract/css';
import { tokens } from '@paypalcorp/pp-react-theme';
function style(rule, debugId) {
  return [_style(rule, debugId), rule];
}
const ppuiEaseLoopStandard = `cubic-bezier(${tokens.motion.easing.loop.standard})`;
const animation = keyframes({
  '0%': {
    backgroundPosition: '100% 0'
  },
  '100%': {
    backgroundPosition: '-100% 0'
  }
}, 'shimmer_animation');
export const [base, baseStyles] = style({
  backgroundColor: tokens.color.structure.shimmer,
  border: `${tokens.border.thickness.normal} solid transparent`,
  backgroundImage: `linear-gradient(
    to right,
    ${tokens.color.structure.shimmer} 0%,
    ${tokens.color.structure.sheen} 50%,
    ${tokens.color.structure.shimmer} 100%
  )`,
  backgroundPosition: '100% 0',
  backgroundSize: '200%',
  animation: `${animation} ${tokens.motion.duration.loop.standard}
    ${ppuiEaseLoopStandard} infinite`
}, 'shimmer_base');
export const [inverse, inverseStyles] = style({
  backgroundColor: tokens.color.structure.shimmerInverse,
  backgroundImage: `linear-gradient(
    to right,
    ${tokens.color.structure.shimmerInverse} 0%,
    ${tokens.color.structure.sheen} 50%,
    ${tokens.color.structure.shimmerInverse} 100%
  )`
}, 'shimmer_inverse');
export const [defaults, defaultStyles] = style({
  borderRadius: tokens.border.radius.lg,
  width: '100%',
  height: '100%'
}, 'shimmer_default');
__vanilla_filescope__.endFileScope();
